import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from 'redux-form';
import { useDropdown } from '../../../utils/hooks';
import Button from '../../elements/Button';
import Select from '../../fields/SelectBox';
import TextField from '../../fields/Text';
import {
  fetchRegionals,
  fetchRoles,
  fetchSam,
  fetchSbm,
} from '../../layouts/PageBase/actions';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';

export default function UserForm({
  handleSubmit = () => {},
  initialValues = {},
  invalid = true,
}) {
  const dispatch = useDispatch();
  const { values } = useSelector((state) => state.form.userForm);
  const { dataRegionals, dataSam, dataSbm, dataRoles } = useSelector(
    (state) => state.pageBase
  );
  const { message, loading } = useSelector((state) => state.user.add);
  const { message: messageUpdate, loading: loadingUpdate } = useSelector(
    (state) => state.user.edit
  );
  const {
    values: dropdownValues,
    handleBlur,
    handleChange,
  } = useDropdown(
    {
      regionalId: { error: '', touched: false, value: '' },
      samId: { error: '', touched: false, value: '' },
      sbmId: { error: '', touched: false, value: '' },
      roleId: { error: '', touched: false, value: '' },
    },
    initialValues
  );
  const { regionalId, samId, sbmId, roleId } = dropdownValues;

  const onSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...values,
      regional: regionalId?.value || '',
      samId: samId?.value || '',
      sbmId: sbmId?.value || '',
      roleId: roleId?.value,
    };
    handleSubmit(payload);
  };

  useEffect(() => {
    dispatch(fetchRegionals());
    dispatch(fetchRoles());
  }, []);

  useEffect(() => {
    if (samId?.value) {
      dispatch(fetchSbm({ samId: JSON.stringify([samId.value]) }));
    }
  }, [samId?.value]);

  useEffect(() => {
    if (regionalId?.value) {
      setTimeout(() => {
        dispatch(fetchSam({ regional: JSON.stringify([regionalId.value]) }));
      }, 1000);
    }
  }, [regionalId?.value]);

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      {message || messageUpdate ? (
        <p className={styles.error}>{message || messageUpdate}</p>
      ) : null}
      <div className={styles.dropdown}>
        <label>{fieldsProps.regional.label}</label>
        <Select
          data={[{ value: '', label: 'Semua Regional' }, ...dataRegionals]}
          eventName="regionalId"
          meta={regionalId}
          name="regionalId"
          onBlur={(e) => handleBlur(e, 'regionalId')}
          onChangeSelect={(value) =>
            handleChange(value, 'regionalId', ['samId', 'sbmId'])
          }
          placeholder={fieldsProps.regional.placeholder}
          valueForm={regionalId?.value}
        />
      </div>
      <div className={styles.dropdown}>
        <label>{fieldsProps.sam.label}</label>
        <Select
          data={[{ value: '', label: 'Semua SAM' }, ...dataSam]}
          disabled={!regionalId?.value}
          eventName="samId"
          meta={samId}
          name="samId"
          onBlur={(e) => handleBlur(e, 'samId')}
          onChangeSelect={(value) => handleChange(value, 'samId', ['sbmId'])}
          placeholder={fieldsProps.sam.placeholder}
          valueForm={samId?.value}
        />
      </div>
      <div>
        <label>{fieldsProps.sbm.label}</label>
        <Select
          data={[{ value: '', label: 'Semua SBM' }, ...dataSbm]}
          disabled={!samId?.value}
          eventName="sbmId"
          meta={sbmId}
          name="sbmId"
          onBlur={(e) => handleBlur(e, 'sbmId')}
          onChangeSelect={(value) => handleChange(value, 'sbmId')}
          placeholder={fieldsProps.sbm.placeholder}
          valueForm={sbmId?.value}
        />
      </div>
      <div className={styles.description}>
        <p>
          Pemilihan parameter <strong>Region</strong>,{' '}
          <strong>SAM dan SBM</strong> menentukan data yang akan ditampilkan
          pada beberapa <strong>Menu</strong> tertentu.
        </p>
      </div>
      <div className={styles.divider} />
      <Field component={TextField} inputProps={fieldsProps.name} name="name" />
      <Field
        component={TextField}
        inputProps={fieldsProps.email}
        name="email"
      />
      <div className={styles.divider} />
      <div className={styles.dropdown}>
        <label>{fieldsProps.role.label}</label>
        <Select
          data={dataRoles}
          eventName="roleId"
          hideLabel
          meta={roleId}
          name="roleId"
          onBlur={(e) => handleBlur(e, 'roleId')}
          onChangeSelect={(value) => handleChange(value, 'roleId')}
          placeholder={fieldsProps.role.placeholder}
          valueForm={roleId?.value}
        />
      </div>
      <Button
        disabled={invalid || !roleId?.value || loading || loadingUpdate}
        eventName="userForm"
        fullWidth
        type="submit"
      >
        Simpan
      </Button>
    </form>
  );
}

UserForm.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  type: PropTypes.oneOf(['create', 'update']),
};
